import React, { SyntheticEvent, useState } from 'react';
import logo from '../assets/img/logonuevoblanco.png';
import { Dimmer, Dropdown, DropdownDivider, DropdownItem, DropdownMenu, Loader, Menu, Segment, Image, MenuItem, MenuHeader } from 'semantic-ui-react';
import { useAppContext } from '../hooks/AppProvider';
import { useLocation } from 'react-router-dom';
import { ROLE_MENUS } from '../config/menuConfig';
import { useAuth } from '../hooks/AuthProvider';
import UpdatePasswordModal from '../pages/users/modals/UpdatePasswordModal';

interface RootTemplateProps {
    children: React.ReactNode;
}

const RootTemplate = ({ children }: RootTemplateProps) => {
    const { parentState } = useAppContext();
    const auth = useAuth();
    const location = useLocation();
    const isDashboard = location.pathname === '/';

    const [openModalPassword, setOpenModalPassword] = useState(false);

    const handleLogout = () => {
        auth.logout();
    }

    const handleCancelModalPassword = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModalPassword(false);
    };

    const userRole = auth.userData?.role;
    const menuItems = userRole && ROLE_MENUS[userRole] ? ROLE_MENUS[userRole] : [];

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>

            {/* 1. DIMMER */}
            <Dimmer active={parentState.loading} page>
                <Loader>Cargando...</Loader>
            </Dimmer>

            {/* 2. NAVBAR FIJO ARRIBA */}
            <Menu fixed='top' inverted size="large" style={{ zIndex: 1000, height: '60px' }}>
                <MenuItem
                    as="a"
                    href="/"
                    header
                    className={isDashboard ? 'root-navbar-brand--dashboard' : undefined}
                    style={{ display: "flex", justifyContent: "center", alignItems: "center", width: '250px' }}
                >
                    <Image size="tiny" src={logo} style={{ margin: "auto", height: '36px', width: 'auto' }} />
                </MenuItem>
                <Dropdown item text={auth.userData?.person?.fullName} pointing='top right'>
                    <DropdownMenu>
                        <DropdownItem onClick={() => setOpenModalPassword(true)}>Actualizar Contraseña</DropdownItem>
                        <DropdownDivider />
                        <DropdownItem onClick={handleLogout}>Cerrar session</DropdownItem>
                    </DropdownMenu>
                </Dropdown>

                <UpdatePasswordModal
                    userId={auth.userData?.id || ""}
                    openModal={openModalPassword}
                    onClose={handleCancelModalPassword}
                />
            </Menu>

            {/* 3. CONTENEDOR PRINCIPAL FLEX */}
            <div style={{ display: 'flex', flex: 1, marginTop: '60px' }}>

                {/* SIDEBAR VERTICAL FIJO */}
                <Menu
                    vertical
                    inverted
                    fixed='left'
                    className={isDashboard ? 'root-sidebar--dashboard' : undefined}
                    style={{
                        width: '250px',
                        marginTop: '60px', // Para que empiece debajo del navbar
                        height: 'calc(100vh - 60px)',
                        borderRadius: 0,
                        overflowY: 'auto'
                    }}
                >
                    <MenuHeader style={{ color: '#ffffffe6', fontSize: '1.2rem', fontWeight: 'bold', paddingTop: '10px', paddingBottom: '10px', marginLeft: '16px' }}>MENU</MenuHeader>
                    {menuItems.map((item) => (
                        <MenuItem
                            key={item.key}
                            as={item.as}
                            href={item.href}
                            icon={item.icon}
                            content={item.content}
                            active={location.pathname === item.href}
                        />
                    ))}
                </Menu>

                {/* 4. ÁREA DE CONTENIDO */}
                {/* El margin-left debe ser igual al ancho del sidebar */}
                <main className={isDashboard ? 'root-main--dashboard' : undefined} style={{
                    flex: 1,
                    marginLeft: '250px',
                    padding: '20px',
                    background: '#f4f4f4',
                    minHeight: 'calc(100vh - 60px)'
                }}>
                    <Segment className={`container-custom${isDashboard ? ' root-container--dashboard' : ''}`}>
                        {children}
                    </Segment>
                </main>
            </div>
        </div>
    );
};

export default RootTemplate;
